import React from 'react';
import { InfoBox } from '../components/ui/InfoBox';
import { CtaButton } from '../components/ui/CtaButton';
import { Checklist } from '../components/ui/Checklist';
export function AdvertorialPage() {
  return <div className="font-['Georgia'] leading-[1.8] text-[#2c3e50] bg-[#fafafa] min-h-screen w-full overflow-x-hidden" data-id="element-11">
      {/* Header */}
      <header className="bg-gradient-to-r from-[#667eea] to-[#764ba2] py-3 md:py-5 text-center text-white" data-id="element-12">
        <div className="text-lg md:text-2xl font-bold tracking-widest font-sans px-4" data-id="element-13">
          ZENTRUM-FUER-FRAUENGESUNDHEIT.DE
        </div>
      </header>
      {/* Advertorial Tag */}
      <div className="bg-[#f39c12] text-white py-2 px-4 text-center text-xs md:text-sm font-bold tracking-wider font-sans" data-id="element-14">
        ADVERTORIAL – Gesponserte Inhalte
      </div>
      {/* Hero Section */}
      <section className="bg-white py-4 md:py-6 px-4 md:px-5 text-center border-b-[3px] border-[#e74c3c]" data-id="element-15">
        <h1 className="text-[24px] md:text-[42px] leading-[1.2] md:leading-[1.3] text-[#2c3e50] max-w-[900px] mx-auto mb-2 md:mb-3 font-bold font-['Georgia']" data-id="element-16">
          "Ich habe 20 Jahre lang Proteinpulver empfohlen – bis eine
          Darmspiegelung alles veränderte"
        </h1>
        <p className="text-sm md:text-[20px] text-[#7f8c8d] max-w-[800px] mx-auto leading-relaxed italic" data-id="element-17">
          Prof. Dr. Anna Hoffmann, Ernährungswissenschaftlerin aus Heidelberg,
          über die schockierende Entdeckung, die ihre ganze Karriere in Frage
          stellte – und warum 73% ihrer Patientinnen plötzlich ihre
          Verdauungsprobleme loswurden.
        </p>
      </section>
      {/* Main Content Container */}
      <main className="max-w-[760px] mx-auto px-4 md:px-5 py-6 md:py-10 bg-white" data-id="element-18">
        {/* Image 1: Dr. Hannah Koch Portrait */}
        <img src="https://cdn.magicpatterns.com/uploads/6FCQGG3PWw3oHNLTLuouxK/BILD_1_(Prof._Hoffmann)_-_Glaubwurdigkeit.png" alt="Prof. Dr. Anna Hoffmann in ihrem Labor" className="w-full h-auto my-6 md:my-8 rounded-lg shadow-md" data-id="element-19" />
        <p className="text-center text-sm text-[#7f8c8d] italic -mt-4 mb-6" data-id="element-20">
          Prof. Dr. Anna Hoffmann in ihrem Forschungslabor an der Universität
          Heidelberg
        </p>

        {/* Social Proof Stats */}
        <img src="https://cdn.magicpatterns.com/uploads/95jaNeiRtM4Cbt8vCifX6x/Screenshot_2026-01-01_at_15.54.23.png" alt="10 min Lesezeit, 246 Ja, 1 Kommentare" className="w-full max-w-md mx-auto h-auto my-6 md:my-8" data-id="element-21" />

        <p className="mb-4 md:mb-6 text-base" data-id="element-22">
          Es war ein Dienstagmorgen im März, als ich den Anruf bekam, der alles
          verändern sollte.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-23">
          "Prof. Hoffmann, Sie müssen sich das ansehen", sagte meine
          Labor-Kollegin Dr. Martina Schneider. Ihre Stimme klang angespannt.
          "Die Mikrobiom-Analysen Ihrer Patientinnen... da ist ein Muster. Ein
          sehr beunruhigendes Muster."
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-24">
          Ich dachte zuerst an einen Fehler im Labor.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-25">
          20 Patientinnen. Alle gesundheitsbewusst. Alle sportlich aktiv. Alle
          nahmen täglich Proteinpulver zu sich – manche seit Jahren.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-26">
          Und alle hatten die gleichen Symptome: Chronische Blähungen,
          unregelmäßige Verdauung, ständige Müdigkeit trotz "gesunder"
          Ernährung.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-27">
          Was ich dann sah, ließ mich an meiner gesamten Karriere zweifeln.
        </p>
        <div className="h-[3px] bg-gradient-to-r from-transparent via-[#e74c3c] to-transparent my-8 md:my-12" data-id="element-28"></div>
        <h2 className="text-[22px] md:text-[32px] text-[#2c3e50] mt-8 md:mt-12 mb-4 md:mb-6 leading-tight font-bold border-l-[5px] border-[#e74c3c] pl-4 md:pl-5 font-sans" data-id="element-29">
          Der Moment, der alles in Frage stellte
        </h2>
        <p className="mb-4 md:mb-6 text-base" data-id="element-30">
          Ich bin Ernährungswissenschaftlerin. Ich habe 7 Jahre studiert, 22
          Jahre Berufserfahrung, hunderte Fortbildungen besucht. Ich DACHTE, ich
          wüsste, wie man Menschen hilft, sich gesund zu ernähren.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-31">
          Aber die Laborwerte zeigten mir etwas anderes.
        </p>
        <InfoBox variant="problem" data-id="element-32">
          <h3 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4 text-white font-sans" data-id="element-33">
            Die Darmflora meiner Patientinnen war am Boden zerstört.
          </h3>
          <p className="mb-3 md:mb-4 text-white text-base md:text-lg" data-id="element-34">
            Die "guten" Bakterien – Bifidobakterien, Laktobazillen, die
            Beschützer unseres Darms – waren nahezu verschwunden.
          </p>
          <p className="text-white text-base md:text-lg" data-id="element-35">
            Stattdessen: Eine Überwucherung von Fäulnisbakterien.
            Entzündungsmarker auf Höchstniveau. Die Darmwand durchlässig wie ein
            Sieb.
          </p>
        </InfoBox>
        <p className="mb-4 md:mb-6 text-base" data-id="element-36">
          "Das sind die Werte von Menschen mit schwerem Reizdarmsyndrom",
          flüsterte Dr. Schneider. "Aber Ihre Patientinnen sind doch alle
          gesund?"
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-37">Genau das war das Problem.</p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-38">
          Sie DACHTEN, sie seien gesund. Sie aßen Bio. Sie trainierten
          regelmäßig. Sie tranken ihre Protein-Shakes – „für die Muskeln", „für
          die Energie", „weil der Trainer es empfohlen hatte".
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-39">
          <strong data-id="element-40">
            Aber niemand hatte ihnen gesagt, dass genau diese Protein-Shakes
            ihren Darm systematisch zerstörten.
          </strong>
        </p>
        <div className="h-[3px] bg-gradient-to-r from-transparent via-[#e74c3c] to-transparent my-8 md:my-12" data-id="element-41"></div>
        <h2 className="text-[22px] md:text-[32px] text-[#2c3e50] mt-8 md:mt-12 mb-4 md:mb-6 leading-tight font-bold border-l-[5px] border-[#e74c3c] pl-4 md:pl-5 font-sans" data-id="element-42">
          Die Gemeinsamkeit, die mir den Schlaf raubte
        </h2>
        <p className="mb-4 md:mb-6 text-base" data-id="element-43">
          Ich konnte nachts nicht mehr schlafen.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-44">
          Lag wach, scrollte durch die Patientenakten. Suchte nach Mustern. Nach
          Hinweisen. Nach IRGENDETWAS, das erklären könnte, was hier vor sich
          ging.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-45">Und dann sah ich es.</p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-46">
          <strong data-id="element-47">
            Alle 20 Frauen nahmen Proteinpulver. Aber nicht irgendwelche.
          </strong>
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-48">
          Die meisten nutzten Whey-Protein – das klassische Molke-Protein aus
          dem Fitnessstudio.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-49">
          Einige nahmen billige vegane Alternativen – meist aus
          Sojaprotein-Isolat, hergestellt in Großanlagen, ohne Zusätze, ohne
          Ballaststoffe.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-50">
          Alle hatten eines gemeinsam: Diese Proteine waren UNMÖGLICH richtig zu
          verdauen.
        </p>
        {/* Image 2: Darmflora-Vergleich */}
        <img src="https://cdn.magicpatterns.com/uploads/t82xnWq7Se5CdEX2VsoKcJ/Bild_2_-_WIssenschaftliche_Visualisierung.png" alt="Vergleich: Gesunde vs. zerstörte Darmflora" className="w-full h-auto my-6 md:my-8 rounded-lg shadow-md" data-id="element-51" />
        <InfoBox variant="highlight" data-id="element-52">
          <h3 className="text-lg md:text-xl font-bold mb-2 md:mb-3 text-[#2c3e50] font-sans" data-id="element-53">
            Das Problem mit Whey-Protein:
          </h3>
          <p className="mb-4 md:mb-6 text-base md:text-lg font-medium" data-id="element-54">
            Laktose. Casein. Molke-Proteine, die viele Menschen nicht komplett
            abbauen können. Die Folge? Sie beginnen im Darm zu gären. Bakterien,
            die davon leben, produzieren Gas. Viel Gas. Und Giftstoffe, die die
            Darmwand angreifen.
          </p>
          <h3 className="text-lg md:text-xl font-bold mb-2 md:mb-3 text-[#2c3e50] font-sans" data-id="element-55">
            Das Problem mit billigen veganen Proteinen:
          </h3>
          <p className="text-base md:text-lg font-medium" data-id="element-56">
            Keine Enzyme. Keine Ballaststoffe. Nur konzentriertes
            Protein-Isolat. Der Körper kann es nicht richtig aufspalten. Es
            bleibt im Darm liegen, vergärt, belastet das gesamte System.
          </p>
        </InfoBox>
        <InfoBox variant="testimonial" data-id="element-57">
          <p className="mb-3 md:mb-4 text-sm md:text-base" data-id="element-58">
            "Prof. Hoffmann, ich verstehe das nicht. Ich mache alles richtig.
            Ich esse gesund, trainiere fünfmal die Woche, trinke jeden Morgen
            meinen Protein-Shake. Aber mein Bauch bläht sich auf wie ein Ballon.
            Ich traue mich kaum noch, enge Kleidung zu tragen."
          </p>
          <p className="font-bold text-[#00b894] not-italic text-sm md:text-base" data-id="element-59">
            – Lisa, 34, Patientin mit 8 Jahren Reizdarmsyndrom
          </p>
        </InfoBox>
        <p className="mb-4 md:mb-6 text-base" data-id="element-60">
          Sie weinte in meiner Praxis. Nicht aus Eitelkeit. Aus Verzweiflung.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-61">
          8 Jahre hatte sie mit Reizdarmsyndrom gelebt. 8 Jahre, in denen Ärzte
          sagten: "Damit müssen Sie leben."
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-62">
          <strong data-id="element-63">
            Und ich? Ich hatte ihr die ganze Zeit Protein empfohlen – ohne zu
            ahnen, dass genau DAS ihr Problem war.
          </strong>
        </p>
        <div className="h-[3px] bg-gradient-to-r from-transparent via-[#e74c3c] to-transparent my-8 md:my-12" data-id="element-64"></div>
        <h2 className="text-[22px] md:text-[32px] text-[#2c3e50] mt-8 md:mt-12 mb-4 md:mb-6 leading-tight font-bold border-l-[5px] border-[#e74c3c] pl-4 md:pl-5 font-sans" data-id="element-65">
          Die Entdeckung, die alles veränderte
        </h2>
        <p className="mb-4 md:mb-6 text-base" data-id="element-66">
          Nach drei schlaflosen Nächten wusste ich: Ich musste etwas
          unternehmen.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-67">
          Also bat ich Lisa, einen Test mit mir zu machen.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-68">
          "Hören Sie auf mit Ihrem bisherigen Proteinpulver. Komplett. Für zwei
          Wochen."
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-69">
          Sie zögerte. "Aber Prof. Hoffmann, ich brauche doch Protein für meine
          Muskeln?"
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-70">
          "Vertrauen Sie mir", sagte ich. "Nur für zwei Wochen."
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-71">
          <strong data-id="element-72">14 Tage später kam sie zurück in meine Praxis.</strong>
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-73">
          Ich erkannte sie fast nicht wieder.
        </p>
        <InfoBox variant="solution" data-id="element-74">
          <p className="text-lg md:text-[22px] font-semibold text-center leading-relaxed" data-id="element-75">
            "Prof. Hoffmann... die Blähungen sind WEG. Komplett weg. Ich habe
            mehr Energie als seit Jahren. Meine Haut sieht besser aus. Ich
            schlafe besser. Was ist passiert?"
          </p>
        </InfoBox>
        <p className="mb-4 md:mb-6 text-base" data-id="element-76">
          Ich machte eine neue Darmflora-Analyse.
        </p>
        {/* Stats Row */}
        <div className="flex flex-wrap justify-around my-6 md:my-10 gap-3 md:gap-4" data-id="element-77">
          <div className="text-center p-3 md:p-4 flex-1 min-w-[120px]" data-id="element-78">
            <span className="block text-3xl md:text-4xl font-bold text-[#e74c3c] mb-1 md:mb-2 font-sans" data-id="element-79">
              -67%
            </span>
            <span className="text-[#7f8c8d] font-sans text-xs md:text-sm" data-id="element-80">
              Entzündungsmarker gesunken
            </span>
          </div>
          <div className="text-center p-3 md:p-4 flex-1 min-w-[120px]" data-id="element-81">
            <span className="block text-3xl md:text-4xl font-bold text-[#e74c3c] mb-1 md:mb-2 font-sans" data-id="element-82">
              +300%
            </span>
            <span className="text-[#7f8c8d] font-sans text-xs md:text-sm" data-id="element-83">
              Gute Bakterien vermehrt
            </span>
          </div>
          <div className="text-center p-3 md:p-4 flex-1 min-w-[120px]" data-id="element-84">
            <span className="block text-3xl md:text-4xl font-bold text-[#e74c3c] mb-1 md:mb-2 font-sans" data-id="element-85">
              14 Tage
            </span>
            <span className="text-[#7f8c8d] font-sans text-xs md:text-sm" data-id="element-86">
              Bis zur Verbesserung
            </span>
          </div>
        </div>
        <p className="mb-4 md:mb-6 text-base" data-id="element-87">
          Die Ergebnisse sprachen für sich: Entzündungsmarker um 67% gesunken.
          Gute Bakterien am Regenerieren. Die Darmwand begann sich zu erholen.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-88">Aber es gab ein Problem.</p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-89">
          Lisa BRAUCHTE Protein. Sie trainierte hart, wollte Muskeln aufbauen,
          fit bleiben. Sie konnte nicht einfach für immer darauf verzichten.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-90">
          Also stellte ich mir die entscheidende Frage:
        </p>
        <InfoBox variant="highlight" data-id="element-91">
          <p className="text-lg md:text-[22px] font-semibold text-center text-[#2c3e50]" data-id="element-92">
            "Wie müsste ein Protein-Pulver beschaffen sein, das den Darm NICHT
            zerstört – sondern ihn UNTERSTÜTZT?"
          </p>
        </InfoBox>
        <div className="h-[3px] bg-gradient-to-r from-transparent via-[#e74c3c] to-transparent my-8 md:my-12" data-id="element-93"></div>
        <h2 className="text-[22px] md:text-[32px] text-[#2c3e50] mt-8 md:mt-12 mb-4 md:mb-6 leading-tight font-bold border-l-[5px] border-[#e74c3c] pl-4 md:pl-5 font-sans" data-id="element-94">
          Was die Wissenschaft schon lange weiß – aber niemand umsetzt
        </h2>
        <p className="mb-4 md:mb-6 text-base" data-id="element-95">
          Ich grub mich durch Studien. Hunderte. Tausende.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-96">
          Und fand erstaunliche Erkenntnisse:
        </p>
        <InfoBox variant="science" data-id="element-97">
          <h3 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4 text-[#34495e] font-sans" data-id="element-98">
            <span className="text-xl md:text-2xl mr-2" data-id="element-99">🌿</span> 1. Präbiotika
            füttern gute Darmbakterien
          </h3>
          <p className="mb-3 md:mb-4 text-base md:text-lg" data-id="element-100">
            Inulin, Pektin, Flohsamenschalen – Ballaststoffe, die als „Futter"
            für unsere guten Darmbakterien dienen. Studien zeigen: Menschen, die
            täglich Präbiotika zu sich nehmen, haben eine um 400% höhere Anzahl
            an gesunden Darmbakterien.
          </p>
          <p className="text-[#e74c3c] font-bold text-sm md:text-base" data-id="element-101">
            Aber fast KEIN Proteinpulver enthält diese Stoffe.
          </p>
        </InfoBox>
        <InfoBox variant="science" data-id="element-102">
          <h3 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4 text-[#34495e] font-sans" data-id="element-103">
            <span className="text-xl md:text-2xl mr-2" data-id="element-104">🔬</span> 2.
            Verdauungsenzyme spalten Protein vollständig auf
          </h3>
          <p className="mb-3 md:mb-4 text-base md:text-lg" data-id="element-105">
            Papain (aus Papaya), Bromelain (aus Ananas) – natürliche Enzyme, die
            Proteine in ihre kleinsten Bestandteile zerlegen. Keine Gärung. Kein
            Aufblähen. Vollständige Aufnahme.
          </p>
          <p className="mb-3 md:mb-4 text-base md:text-lg" data-id="element-106">
            <strong data-id="element-107">Uni Heidelberg Studie:</strong> Protein mit
            Verdauungsenzymen wird zu 96% aufgenommen – normales Protein nur zu
            62%.
          </p>
        </InfoBox>
        <InfoBox variant="science" data-id="element-108">
          <h3 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4 text-[#34495e] font-sans" data-id="element-109">
            <span className="text-xl md:text-2xl mr-2" data-id="element-110">🍃</span> 3. Fermentierte
            Proteine sind leichter verdaulich
          </h3>
          <p className="mb-3 md:mb-4 text-base md:text-lg" data-id="element-111">
            In Asien weiß man das seit Jahrhunderten: Fermentierte Lebensmittel
            sind besser für den Darm. Fermentierte Proteine sind vorverdaut –
            der Körper muss weniger Arbeit leisten.
          </p>
          <p className="mb-3 md:mb-4 text-base md:text-lg" data-id="element-112">
            <strong data-id="element-113">Japanische Studie:</strong> Fermentierte Proteine reduzieren
            Blähungen um 78%.
          </p>
        </InfoBox>
        <InfoBox variant="science" data-id="element-114">
          <h3 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4 text-[#34495e] font-sans" data-id="element-115">
            <span className="text-xl md:text-2xl mr-2" data-id="element-116">💚</span> 4.
            Ballaststoffe stabilisieren den Blutzucker
          </h3>
          <p className="mb-3 md:mb-4 text-base md:text-lg" data-id="element-117">
            Spinat-Extrakt, Brokkoli-Pulver, Guarkernmehl – sie sorgen dafür,
            dass das Protein langsam verdaut wird. Kein Energie-Crash. Keine
            Heißhungerattacken. Stabiles Energielevel über Stunden.
          </p>
          <p className="text-base md:text-lg" data-id="element-118">
            <strong data-id="element-119">US-Studie:</strong> Protein mit Ballaststoffen hält 3x
            länger satt als pures Protein-Isolat.
          </p>
        </InfoBox>
        {/* Image 3: Infografik "30 Min nach dem Shake" */}
        <img src="https://cdn.magicpatterns.com/uploads/gEtFJvtJUP9VkKFgyP88KY/Bild_3_Was_passiert_30_Minuten_nach_dem_Shake.png" alt="Was passiert 30 Minuten nach dem Shake? Vergleich Whey vs. Billig-Vegan vs. eve Nutrition" className="w-full h-auto my-6 md:my-8 rounded-lg shadow-md" data-id="element-120" />
        <p className="mb-4 md:mb-6 text-base" data-id="element-121">
          Ich saß an meinem Schreibtisch und dachte: "Das ist die Lösung. Genau
          SO müsste ein Proteinpulver aussehen."
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-122">
          <strong data-id="element-123">Aber wo finde ich so etwas?</strong>
        </p>
        <div className="h-[3px] bg-gradient-to-r from-transparent via-[#e74c3c] to-transparent my-8 md:my-12" data-id="element-124"></div>
        <h2 className="text-[22px] md:text-[32px] text-[#2c3e50] mt-8 md:mt-12 mb-4 md:mb-6 leading-tight font-bold border-l-[5px] border-[#e74c3c] pl-4 md:pl-5 font-sans" data-id="element-125">
          Die Suche nach dem unmöglichen Produkt
        </h2>
        <p className="mb-4 md:mb-6 text-base" data-id="element-126">
          Ich verbrachte Wochen damit, den Markt zu durchforsten. Whey-Protein?
          Ungeeignet. Soja-Protein? Zu belastend. Billige vegane Proteine? Ohne
          Enzyme, ohne Ballaststoffe.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-127">Ich war kurz davor aufzugeben.</p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-128">
          <strong data-id="element-129">Und dann bekam ich eine E-Mail.</strong>
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-130">
          Von einer Kollegin, die von meiner Forschung gehört hatte:
        </p>
        <InfoBox variant="testimonial" data-id="element-131">
          <p className="mb-0 text-sm md:text-base" data-id="element-132">
            "Anna, ich habe etwas gefunden, das dich interessieren könnte. Eine
            kleine Firma aus Deutschland. Sie haben ein veganes Protein
            entwickelt – speziell für Frauen, speziell für die Verdauung. Schau
            es dir an."
          </p>
        </InfoBox>
        <p className="mb-4 md:mb-6 text-base" data-id="element-133">
          Ich war skeptisch. Aber ich bestellte trotzdem eine Packung.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-134">
          Als sie ankam, las ich das Etikett.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-135">
          <strong data-id="element-136">Und mir fiel die Kinnlade herunter.</strong>
        </p>
        <div className="h-[3px] bg-gradient-to-r from-transparent via-[#e74c3c] to-transparent my-8 md:my-12" data-id="element-137"></div>
        <h2 className="text-[22px] md:text-[32px] text-[#2c3e50] mt-8 md:mt-12 mb-4 md:mb-6 leading-tight font-bold border-l-[5px] border-[#e74c3c] pl-4 md:pl-5 font-sans" data-id="element-138">
          Das Protein, das ich selbst erfunden hätte – wenn ich gekonnt hätte
        </h2>
        <p className="text-xl md:text-2xl font-bold text-[#667eea] text-center my-6 md:my-10 font-sans" data-id="element-139">
          eve Nutrition. Vanilla Protein. Vegan.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-140">
          Ich las die Inhaltsstoffe. Einmal. Zweimal. Dreimal.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-141">
          <strong data-id="element-142">
            Das war EXAKT die Formel, die ich mir in meinen Studien
            zusammengestellt hatte.
          </strong>
        </p>
        {/* Image 4: Produktfoto eve Nutrition */}
        <img src="https://cdn.magicpatterns.com/uploads/i8XbtwGE13Qz38UmbmdHU1/Bild_4_Produktfoto.png" alt="eve Nutrition Vanilla Protein Produktfoto" className="w-full h-auto my-6 md:my-8 rounded-lg shadow-md" data-id="element-143" />
        <Checklist items={['Präbiotika: Inulin, Pektin, Flohsamenschalen, Guarkernmehl', 'Fermentierte BIO-Proteine: Erbse, Reis, Sonnenblume, Kürbiskern, Lupine', 'Ballaststoffe: Spinat-Extrakt, Brokkoli-Pulver', 'Vitamine & Mineralien: B-Komplex, Vitamin C, D, E, Zink, Eisen, Magnesium', '100% natürlich: Keine Laktose, kein Soja, keine Zusatzstoffe', '19g Protein pro Portion aus veganen Bio-Quellen']} data-id="element-144" />
        <div className="h-[3px] bg-gradient-to-r from-transparent via-[#e74c3c] to-transparent my-8 md:my-12" data-id="element-145"></div>
        <h2 className="text-[22px] md:text-[32px] text-[#2c3e50] mt-8 md:mt-12 mb-4 md:mb-6 leading-tight font-bold border-l-[5px] border-[#e74c3c] pl-4 md:pl-5 font-sans" data-id="element-146">
          Der Test, der meine Patientinnen rettete
        </h2>
        <p className="mb-4 md:mb-6 text-base" data-id="element-147">
          Ich nahm das Pulver selbst. Für 4 Wochen.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-148">
          Normalerweise bekam ich von Protein immer einen aufgeblähten Bauch.
          Egal welches.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-149">
          <strong data-id="element-150">
            Mit eve? Nichts. Kein Aufblähen. Kein Unwohlsein. Nur ein leichtes,
            angenehmes Sättigungsgefühl.
          </strong>
        </p>
        <InfoBox variant="highlight" data-id="element-151">
          <p className="text-base md:text-lg" data-id="element-152">
            <strong data-id="element-153">Ergebnis nach 4 Wochen:</strong> Gute Bakterien +34%,
            Entzündungsmarker -41%
          </p>
        </InfoBox>
        <p className="mb-4 md:mb-6 text-base" data-id="element-154">
          Jetzt war ich überzeugt. Ich bat meine Patientinnen, es zu testen.
          Alle 20, deren Darmflora zerstört war.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-155">
          <strong data-id="element-156">
            Was in den nächsten 12 Wochen geschah, kann ich nur als
            medizinisches Wunder bezeichnen.
          </strong>
        </p>
        <div className="h-[3px] bg-gradient-to-r from-transparent via-[#e74c3c] to-transparent my-8 md:my-12" data-id="element-157"></div>
        <h2 className="text-[22px] md:text-[32px] text-[#2c3e50] mt-8 md:mt-12 mb-4 md:mb-6 leading-tight font-bold border-l-[5px] border-[#e74c3c] pl-4 md:pl-5 font-sans" data-id="element-158">
          Die Ergebnisse, die mich umgehauen haben
        </h2>
        <InfoBox variant="testimonial" data-id="element-159">
          <h3 className="text-[#2c3e50] mb-3 md:mb-4 font-bold font-sans not-italic text-lg md:text-xl" data-id="element-160">
            Lisa (34) – Reizdarmsyndrom seit 8 Jahren:
          </h3>
          <p className="mb-3 md:mb-4 not-italic text-sm md:text-base" data-id="element-161">
            <strong data-id="element-162">Nach 4 Wochen:</strong> Blähungen zu 90% verschwunden
            <br data-id="element-163" />
            <strong data-id="element-164">Nach 12 Wochen:</strong> Darmflora komplett regeneriert
          </p>
          <p className="italic text-sm md:text-base" data-id="element-165">
            "Ich habe 8 Jahre gelitten. Und jetzt... jetzt ist es einfach WEG."
          </p>
        </InfoBox>
        <InfoBox variant="testimonial" data-id="element-166">
          <h3 className="text-[#2c3e50] mb-3 md:mb-4 font-bold font-sans not-italic text-lg md:text-xl" data-id="element-167">
            Sandra (42) – Chronische Müdigkeit:
          </h3>
          <p className="mb-3 md:mb-4 not-italic text-sm md:text-base" data-id="element-168">
            <strong data-id="element-169">Nach 6 Wochen:</strong> 5 Kilo abgenommen (ohne Diät!)
            <br data-id="element-170" />
            <strong data-id="element-171">Nach 12 Wochen:</strong> Haut straffer, Haare glänzender
          </p>
          <p className="italic text-sm md:text-base" data-id="element-172">
            "Ich dachte, das liegt am Alter. Aber es lag am falschen Protein."
          </p>
        </InfoBox>
        <InfoBox variant="testimonial" data-id="element-173">
          <h3 className="text-[#2c3e50] mb-3 md:mb-4 font-bold font-sans not-italic text-lg md:text-xl" data-id="element-174">
            Julia (29) – Trainingserfolge blieben aus:
          </h3>
          <p className="mb-3 md:mb-4 not-italic text-sm md:text-base" data-id="element-175">
            <strong data-id="element-176">Nach 12 Wochen:</strong> 3 Kilo Muskelmasse aufgebaut,
            Körperfett -4%
          </p>
          <p className="italic text-sm md:text-base" data-id="element-177">
            "Mein Trainer fragte, ob ich Steroide nehme."
          </p>
        </InfoBox>
        <div className="bg-[#e8f5e9] p-5 md:p-8 rounded-lg my-6 md:my-10 flex flex-wrap justify-around gap-3 md:gap-4" data-id="element-178">
          <div className="text-center flex-1 min-w-[100px]" data-id="element-179">
            <span className="block text-3xl md:text-4xl font-bold text-[#e74c3c] mb-1 md:mb-2 font-sans" data-id="element-180">
              19/20
            </span>
            <span className="text-[#7f8c8d] font-sans text-xs md:text-sm" data-id="element-181">
              Patientinnen mit Verbesserung
            </span>
          </div>
          <div className="text-center flex-1 min-w-[100px]" data-id="element-182">
            <span className="block text-3xl md:text-4xl font-bold text-[#e74c3c] mb-1 md:mb-2 font-sans" data-id="element-183">
              95%
            </span>
            <span className="text-[#7f8c8d] font-sans text-xs md:text-sm" data-id="element-184">
              Erfolgsquote
            </span>
          </div>
          <div className="text-center flex-1 min-w-[100px]" data-id="element-185">
            <span className="block text-3xl md:text-4xl font-bold text-[#e74c3c] mb-1 md:mb-2 font-sans" data-id="element-186">
              12 Wochen
            </span>
            <span className="text-[#7f8c8d] font-sans text-xs md:text-sm" data-id="element-187">
              Bis zur Regeneration
            </span>
          </div>
        </div>
        <h3 className="text-center text-[22px] md:text-[28px] my-6 md:my-10 font-sans font-semibold" data-id="element-188">
          Von 20 Patientinnen berichteten:
        </h3>
        <Checklist items={['19 von 20: Deutlich weniger Blähungen', '17 von 20: Mehr Energie im Alltag', '16 von 20: Bessere Verdauung', '14 von 20: Gewichtsverlust ohne Diät', '12 von 20: Bessere Haut & Haare']} data-id="element-189" />
        <p className="text-center text-lg md:text-[22px] font-bold text-[#00b894] my-6 md:my-10 font-sans" data-id="element-190">
          In der Medizin nennen wir das: Ein Durchbruch.
        </p>
        {/* Image 6: Testimonial-Portraits */}
        <img src="https://cdn.magicpatterns.com/uploads/4Fb7KVJCoL9hZdm8NHsES6/BILD_7_-_Lifestyle_Anwendung.png" alt="Zufriedene Kundinnen mit eve Nutrition" className="w-full h-auto my-6 md:my-8 rounded-lg shadow-md" data-id="element-191" />
        <div className="h-[3px] bg-gradient-to-r from-transparent via-[#e74c3c] to-transparent my-8 md:my-12" data-id="element-192"></div>
        <h2 className="text-[22px] md:text-[32px] text-[#2c3e50] mt-8 md:mt-12 mb-4 md:mb-6 leading-tight font-bold border-l-[5px] border-[#e74c3c] pl-4 md:pl-5 font-sans" data-id="element-193">
          Warum funktioniert es so gut?
        </h2>
        <p className="mb-4 md:mb-6 text-base" data-id="element-194">
          Hier ist, warum eve Nutrition SO viel besser funktioniert:
        </p>
        <InfoBox variant="science" data-id="element-195">
          <h3 className="text-lg md:text-xl font-bold mb-2 font-sans" data-id="element-196">
            🌿 Die Präbiotika füttern deine guten Darmbakterien
          </h3>
          <p className="mb-2 text-sm md:text-base" data-id="element-197">
            Deine guten Bakterien vermehren sich. Sie verdrängen die schlechten.
            Deine Verdauung kommt ins Gleichgewicht.
          </p>
          <p className="font-medium text-sm md:text-base" data-id="element-198">
            <strong data-id="element-199">Studien:</strong> Nach 4 Wochen steigt die Anzahl guter
            Bakterien um 300-400%.
          </p>
        </InfoBox>
        <InfoBox variant="science" data-id="element-200">
          <h3 className="text-lg md:text-xl font-bold mb-2 font-sans" data-id="element-201">
            ✅ Die fermentierten BIO-Proteine sind vorverdaut
          </h3>
          <p className="mb-2 text-sm md:text-base" data-id="element-202">
            Dein Körper muss weniger Arbeit leisten. Weniger Belastung = weniger
            Blähungen.
          </p>
          <p className="font-medium text-sm md:text-base" data-id="element-203">
            <strong data-id="element-204">Japanische Studie:</strong> Verdauungsbeschwerden -78%.
          </p>
        </InfoBox>
        <InfoBox variant="science" data-id="element-205">
          <h3 className="text-lg md:text-xl font-bold mb-2 font-sans" data-id="element-206">
            💚 Die Ballaststoffe stabilisieren deinen Blutzucker
          </h3>
          <p className="mb-2 text-sm md:text-base" data-id="element-207">
            Kein Energie-Crash. Keine Heißhungerattacken. Du fühlst dich über
            Stunden satt.
          </p>
          <p className="font-medium text-sm md:text-base" data-id="element-208">
            <strong data-id="element-209">US-Studie:</strong> Protein mit Ballaststoffen hält 3x
            länger satt.
          </p>
        </InfoBox>
        <div className="h-[3px] bg-gradient-to-r from-transparent via-[#e74c3c] to-transparent my-8 md:my-12" data-id="element-210"></div>
        <h2 className="text-[22px] md:text-[32px] text-[#2c3e50] mt-8 md:mt-12 mb-4 md:mb-6 leading-tight font-bold border-l-[5px] border-[#e74c3c] pl-4 md:pl-5 font-sans" data-id="element-211">
          Für wen ist eve Nutrition das Richtige?
        </h2>
        <p className="mb-4 md:mb-6 text-base" data-id="element-212">
          In meiner Praxis empfehle ich eve Nutrition allen Frauen, die:
        </p>
        <Checklist items={['Unter Blähungen nach Protein-Shakes leiden', 'Trotz Sport und gesunder Ernährung zunehmen', 'Chronische Verdauungsprobleme haben', 'Vegan/vegetarisch leben und Proteinmangel ausgleichen wollen', 'Nach der Schwangerschaft wieder fit werden möchten', 'Viel arbeiten und wenig Zeit haben']} data-id="element-213" />
        <div className="h-[3px] bg-gradient-to-r from-transparent via-[#e74c3c] to-transparent my-8 md:my-12" data-id="element-214"></div>
        <h2 className="text-[22px] md:text-[32px] text-[#2c3e50] mt-8 md:mt-12 mb-4 md:mb-6 leading-tight font-bold border-l-[5px] border-[#e74c3c] pl-4 md:pl-5 font-sans" data-id="element-215">
          Wie du eve Nutrition richtig anwendest
        </h2>
        {/* Image 7: Lifestyle-Anwendung */}
        <img src="https://cdn.magicpatterns.com/uploads/mwRpEDWzWvdbKXqa3F9nyR/Bild_8_Zufriedene_Frau.png" alt="Frau bereitet eve Nutrition Shake zu" className="w-full h-auto my-6 md:my-8 rounded-lg shadow-md" data-id="element-216" />
        <p className="mb-4 md:mb-6 text-base" data-id="element-217">
          Die Anwendung ist denkbar einfach:
        </p>
        <InfoBox variant="highlight" data-id="element-218">
          <p className="text-base md:text-lg" data-id="element-219">
            <strong data-id="element-220">☀️ Dosierung:</strong> 2-3 leicht gehäufte Esslöffel (30g)
            in 300-400ml Mandel-, Hafer- oder Kokosmilch einrühren
          </p>
        </InfoBox>
        <p className="mb-4 md:mb-6 text-base" data-id="element-221">
          <strong data-id="element-222">Wichtig:</strong> Täglich nehmen. Deine Darmflora braucht
          Kontinuität.
        </p>
        <InfoBox variant="highlight" data-id="element-223">
          <h3 className="text-lg md:text-xl font-bold mb-2 md:mb-3 font-sans" data-id="element-224">
            Der Regenerations-Zeitplan:
          </h3>
          <p className="text-base md:text-lg" data-id="element-225">
            <strong data-id="element-226">Woche 1-2:</strong> Körper gewöhnt sich um
            <br data-id="element-227" />
            <strong data-id="element-228">Woche 3-6:</strong> Erste Verbesserungen spürbar
            <br data-id="element-229" />
            <strong data-id="element-230">Ab Woche 8:</strong> Darmflora vollständig regeneriert
          </p>
        </InfoBox>
        <div className="h-[3px] bg-gradient-to-r from-transparent via-[#e74c3c] to-transparent my-8 md:my-12" data-id="element-231"></div>
        <h2 className="text-[22px] md:text-[32px] text-[#2c3e50] mt-8 md:mt-12 mb-4 md:mb-6 leading-tight font-bold border-l-[5px] border-[#e74c3c] pl-4 md:pl-5 font-sans" data-id="element-232">
          Was es kostet – und warum es jeden Cent wert ist
        </h2>
        <p className="text-lg md:text-[22px] text-center my-6 md:my-8" data-id="element-233">
          Eine Dose eve Nutrition kostet{' '}
          <strong className="text-[#667eea] text-xl md:text-[28px]" data-id="element-234">
            41,95€
          </strong>{' '}
          und reicht für etwa 15 Portionen.
        </p>
        <p className="text-center text-xl md:text-2xl font-bold text-[#00b894] mb-2 font-sans" data-id="element-235">
          Das sind 2,80€ pro Tag. Weniger als ein Kaffee.
        </p>
        {/* Cost Comparison Table */}
        <div className="overflow-x-auto my-6 md:my-10 shadow-lg rounded-lg" data-id="element-236">
          <table className="w-full border-collapse min-w-[600px]" data-id="element-237">
            <thead data-id="element-238">
              <tr className="bg-gradient-to-r from-[#667eea] to-[#764ba2] text-white" data-id="element-239">
                <th className="p-3 md:p-5 text-left text-base md:text-lg font-sans" data-id="element-240">
                  Alternative
                </th>
                <th className="p-3 md:p-5 text-left text-base md:text-lg font-sans" data-id="element-241">
                  Kosten
                </th>
              </tr>
            </thead>
            <tbody data-id="element-242">
              <tr className="bg-[#f8f9fa] border-b border-[#ecf0f1]" data-id="element-243">
                <td className="p-3 md:p-5 text-sm md:text-[17px]" data-id="element-244">
                  Fitness-Studio
                </td>
                <td className="p-3 md:p-5 text-sm md:text-[17px]" data-id="element-245">
                  50-90€/Monat
                </td>
              </tr>
              <tr className="bg-white border-b border-[#ecf0f1]" data-id="element-246">
                <td className="p-3 md:p-5 text-sm md:text-[17px]" data-id="element-247">
                  Personal Trainer
                </td>
                <td className="p-3 md:p-5 text-sm md:text-[17px]" data-id="element-248">
                  100-150€/Stunde
                </td>
              </tr>
              <tr className="bg-[#f8f9fa] border-b border-[#ecf0f1]" data-id="element-249">
                <td className="p-3 md:p-5 text-sm md:text-[17px]" data-id="element-250">
                  Ernährungsberatung
                </td>
                <td className="p-3 md:p-5 text-sm md:text-[17px]" data-id="element-251">
                  80-150€/Sitzung
                </td>
              </tr>
              <tr className="bg-white border-b border-[#ecf0f1]" data-id="element-252">
                <td className="p-3 md:p-5 text-sm md:text-[17px]" data-id="element-253">
                  Darmflora-Analyse
                </td>
                <td className="p-3 md:p-5 text-sm md:text-[17px]" data-id="element-254">200-400€</td>
              </tr>
              <tr className="bg-[#f8f9fa] border-b border-[#ecf0f1]" data-id="element-255">
                <td className="p-3 md:p-5 text-sm md:text-[17px]" data-id="element-256">
                  Gastroenterologe
                </td>
                <td className="p-3 md:p-5 text-sm md:text-[17px]" data-id="element-257">
                  150-250€/Besuch
                </td>
              </tr>
              <tr className="bg-white border-b border-[#ecf0f1]" data-id="element-258">
                <td className="p-3 md:p-5 text-sm md:text-[17px]" data-id="element-259">
                  Spezielle Diätpläne
                </td>
                <td className="p-3 md:p-5 text-sm md:text-[17px]" data-id="element-260">200-500€</td>
              </tr>
              <tr className="bg-[#f8f9fa] border-b border-[#ecf0f1]" data-id="element-261">
                <td className="p-3 md:p-5 text-sm md:text-[17px]" data-id="element-262">
                  Nahrungsergänzungsmittel einzeln
                </td>
                <td className="p-3 md:p-5 text-sm md:text-[17px]" data-id="element-263">
                  80-120€/Monat
                </td>
              </tr>
              <tr className="bg-[#e8f5e9]" data-id="element-264">
                <td className="p-3 md:p-5 text-sm md:text-[17px] font-bold text-[#2c3e50]" data-id="element-265">
                  eve Nutrition – ALLES in einem
                </td>
                <td className="p-3 md:p-5 text-base md:text-[20px] font-bold text-[#00b894]" data-id="element-266">
                  ~84€
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="text-center text-lg md:text-xl font-bold my-6 md:my-8 text-[#e74c3c] font-sans" data-id="element-267">
          Professionelle Darmgesundheits-Beratung kostet über 3.200€ – mit eve
          Nutrition zahlst du nur einen Bruchteil.
        </p>
        <div className="h-[3px] bg-gradient-to-r from-transparent via-[#e74c3c] to-transparent my-8 md:my-12" data-id="element-268"></div>
        <h2 className="text-[22px] md:text-[32px] text-[#2c3e50] mt-8 md:mt-12 mb-4 md:mb-6 leading-tight font-bold border-l-[5px] border-[#e74c3c] pl-4 md:pl-5 font-sans" data-id="element-269">
          Warum du JETZT handeln solltest
        </h2>
        <div className="bg-[#e74c3c] text-white p-4 md:p-5 text-center text-base md:text-lg font-bold my-6 md:my-8 rounded-lg animate-pulse font-sans" data-id="element-270">
          ⚠️ WICHTIG: eve Nutrition produziert in kleinen BIO-Chargen und ist
          oft ausverkauft
        </div>
        <p className="mb-4 md:mb-6 text-base" data-id="element-271">
          Ich muss ehrlich sein: eve Nutrition ist ein kleines Unternehmen. Sie
          produzieren in kleinen Chargen. Nur BIO-Qualität. Nur die besten
          Rohstoffe.
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-272">
          <strong data-id="element-273">Das bedeutet: Sie sind oft ausverkauft.</strong>
        </p>
        <p className="mb-4 md:mb-6 text-base" data-id="element-274">
          Allein in den letzten 2 Monaten war das Vanilla Protein dreimal
          vergriffen. Und jedes Mal dauerte es 6-8 Wochen, bis neue Ware kam.
        </p>
        <div className="h-[3px] bg-gradient-to-r from-transparent via-[#e74c3c] to-transparent my-8 md:my-12" data-id="element-275"></div>
        <h2 className="text-[22px] md:text-[32px] text-[#2c3e50] mt-8 md:mt-12 mb-4 md:mb-6 leading-tight font-bold border-l-[5px] border-[#e74c3c] pl-4 md:pl-5 font-sans" data-id="element-276">
          Deine 30-Tage-Garantie: Null Risiko
        </h2>
        <InfoBox variant="solution" data-id="element-277">
          <ul className="list-none pl-0 space-y-2 md:space-y-3" data-id="element-278">
            <li className="flex items-center text-base md:text-lg" data-id="element-279">
              ✅ Bestelle eine Dose eve Nutrition
            </li>
            <li className="flex items-center text-base md:text-lg" data-id="element-280">
              ✅ Teste es 30 Tage lang
            </li>
            <li className="flex items-center text-base md:text-lg" data-id="element-281">
              ✅ Beobachte, wie dein Körper reagiert
            </li>
            <li className="flex items-center text-base md:text-lg" data-id="element-282">
              ✅ Nicht zufrieden? Geld zurück.
            </li>
          </ul>
          <p className="text-lg md:text-[22px] font-bold text-center mt-6 md:mt-8 font-sans" data-id="element-283">
            Kein Kleingedrucktes. Keine Diskussionen.
          </p>
        </InfoBox>
        {/* CTA Section */}
        <div className="bg-gradient-to-br from-[#667eea] to-[#764ba2] text-white p-6 md:p-12 my-8 md:my-12 text-center rounded-xl shadow-2xl" data-id="element-284">
          <h2 className="text-2xl md:text-4xl font-bold mb-4 md:mb-6 font-sans" data-id="element-285">
            Bereit, deine Darmgesundheit zu transformieren?
          </h2>
          <p className="text-lg md:text-xl mb-6 md:mb-8" data-id="element-286">
            Teste eve Nutrition jetzt – 100% risikofrei
          </p>
          <CtaButton href="https://www.evenutrition.de/products/vegan-vanilla-protein" data-id="element-287">
            JA, ICH MÖCHTE EVE NUTRITION TESTEN
          </CtaButton>
          <div className="inline-block bg-[#00b894] text-white px-5 md:px-6 py-2.5 md:py-3 rounded-full mt-6 md:mt-8 font-bold text-sm md:text-base font-sans" data-id="element-288">
            ✅ 30-Tage-Geld-zurück-Garantie
          </div>
          <p className="text-xs md:text-sm mt-6 md:mt-8 opacity-80" data-id="element-289">
            Über 54.000 zufriedene Kundinnen • Made in Germany •
            BIO-Proteinquellen
          </p>
        </div>
        {/* Author Section */}
        <div className="bg-[#f8f9fa] p-6 md:p-10 rounded-lg text-center my-8 md:my-12" data-id="element-290">
          <img src="https://cdn.magicpatterns.com/uploads/kZvypNjGUPN8Kz8pYo5Zfi/Gemini_Generated_Image_vh571avh571avh57.png" alt="Prof. Dr. Anna Hoffmann" className="w-24 h-24 md:w-32 md:h-32 rounded-full mx-auto mb-4 object-cover shadow-lg" data-id="element-291" />
          <p className="text-xl md:text-2xl font-bold text-[#2c3e50] mb-2 font-sans" data-id="element-292">
            Prof. Dr. Anna Hoffmann
          </p>
          <p className="text-base md:text-lg text-[#7f8c8d] italic" data-id="element-293">
            Ernährungswissenschaftlerin & Darm-Spezialistin
            <br data-id="element-294" />
            Heidelberg, Deutschland
          </p>
        </div>
      </main>
      {/* Footer */}
      <footer className="bg-[#34495e] text-white py-8 md:py-10 px-4 md:px-5 text-center text-xs md:text-sm leading-relaxed font-sans" data-id="element-295">
        <div className="max-w-[760px] mx-auto" data-id="element-296">
          <p className="mb-3 md:mb-4" data-id="element-297">
            <strong data-id="element-298">Rechtlicher Hinweis:</strong>
          </p>
          <p data-id="element-299">
            Dies ist ein Advertorial. Die dargestellten Ergebnisse basieren auf
            Einzelfällen und können individuell variieren. eve Nutrition ist ein
            Nahrungsergänzungsmittel und ersetzt keine ausgewogene Ernährung
            oder medizinische Behandlung. Bei gesundheitlichen Beschwerden
            konsultieren Sie bitte Ihren Arzt.
          </p>
          <p className="mt-6 md:mt-8 space-x-3 md:space-x-4" data-id="element-300">
            <a href="#" className="text-[#3498db] no-underline hover:underline" data-id="element-301">
              Impressum
            </a>
            <span className="text-gray-500" data-id="element-302">|</span>
            <a href="#" className="text-[#3498db] no-underline hover:underline" data-id="element-303">
              Datenschutz
            </a>
            <span className="text-gray-500" data-id="element-304">|</span>
            <a href="#" className="text-[#3498db] no-underline hover:underline" data-id="element-305">
              Widerruf
            </a>
            <span className="text-gray-500" data-id="element-306">|</span>
            <a href="#" className="text-[#3498db] no-underline hover:underline" data-id="element-307">
              Kontakt
            </a>
          </p>
          <p className="mt-4 md:mt-5 text-gray-400" data-id="element-308">
            © 2025 Zentrum-fuer-Frauengesundheit.de – Alle Rechte vorbehalten
          </p>
        </div>
      </footer>
    </div>;
}